export default __webpack_public_path__ + "static/media/local-news-mobile.894beb23.png";